export default "__VITE_ASSET__VxLUrDB$__";